import { Component, inject } from '@angular/core';
import { Review } from '../review/review';
import { ReviewService } from '../../service/review-service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-reviews',
  imports: [Review, AsyncPipe],
  templateUrl: './reviews.html',
  styleUrl: './reviews.scss'
})
export class Reviews {
  private reviewService = inject(ReviewService);
  reviews$ = this.reviewService.getLimitedReviews();
}
